function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "diets");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings",
  transform: "translate(-31.000000, -266.000000)",
  stroke: "#155C28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection",
  transform: "translate(10.000000, 250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "diets",
  transform: "translate(22.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 20,
  x2: 3,
  y2: 17,
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.98067585,7 L4.02874344,7.05 C5.29091089,8.36277518 6,10.1433608 6,12 C6,13.8566392 5.29091089,15.6372248 4.02874344,16.95 L3.01932415,18 L2.97125656,17.95 C1.70908911,16.6372248 1,14.8566392 1,13 C1,11.1433608 1.70908911,9.36277518 2.97125656,8.05 L3.98067585,7 Z",
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,17.0193241 L13.95,16.9712566 C12.6372248,15.7090891 10.8566392,15 9,15 C7.14336081,15 5.36277518,15.7090891 4.05,16.9712566 L3,17.9806759 L3.05,18.0287434 C4.36277518,19.2909109 6.14336081,20 8,20 C9.85663919,20 11.6372248,19.2909109 12.95,18.0287434 L14,17.0193241 Z",
  id: "Path",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.54991963,11 L9.45000179,10.889 C7.51666607,8.74113637 7.51666607,5.25886363 9.45000179,3.111 L10.4500804,2 L10.5499982,2.111 C12.4833339,4.25886363 12.4833339,7.74113637 10.5499982,9.889 L9.54991963,11",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,11.4500804 L9.111,11.5499982 C11.2588636,13.4833339 14.7411364,13.4833339 16.889,11.5499982 L18,10.5499196 L17.889,10.4500018 C15.7411364,8.51666607 12.2588636,8.51666607 10.111,10.4500018 L9,11.4500804",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1575718,1.61414275 C16.7555731,0.0161414275 20,0 20,0 C20,0 19.9838586,3.24442692 18.3858573,4.84242824 C16.7878559,6.44042956 14.0814766,5.9185234 14.0814766,5.9185234 C14.0814766,5.9185234 13.5595704,3.21214406 15.1575718,1.61414275 Z",
  id: "Path",
  strokeLinecap: "square"
})))));

var SvgDiets = function SvgDiets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diets.1ae91936.svg";
export { ForwardRef as ReactComponent };